import client from "./client.js";

export const fetchRoutingRules = () =>
  client.get("/routing-rules").then((r) => r.data.data);

export const fetchRoutingRule = (id) =>
  client.get(`/routing-rules/${id}`).then((r) => r.data.data);

export const createRoutingRule = (payload) =>
  client.post("/routing-rules", payload).then((r) => r.data.data);

export const updateRoutingRule = (id, payload) =>
  client.patch(`/routing-rules/${id}`, payload).then((r) => r.data.data);

export const deleteRoutingRule = (id) => client.delete(`/routing-rules/${id}`);

export const previewRoutingRules = (payload) =>
  client.post("/routing-rules/preview", payload).then((r) => r.data.data);

export const fetchRoutingEvaluations = (incidentId, limit = 20) =>
  client
    .get("/routing-rules/evaluations", { params: { incident_id: incidentId, limit } })
    .then((r) => r.data.data);
